import _regenerator from "/home/jenkins/agent/workspace/usedcar-vue-mobile-uat-frontend/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/home/jenkins/agent/workspace/usedcar-vue-mobile-uat-frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import Vue from 'vue';
// 平台环境变量
var PLATFORM = process.env.VUE_APP_PLATFORM;
var platformMap = {
  'h5': 'h5',
  'cordova': 'cordova-h5'
};
// #ifdef CORDOVA
PLATFORM = platformMap.cordova;
// #endif
// #ifdef H5-BROSWER
PLATFORM = platformMap.h5;
// #endif
console.log(PLATFORM);
// h5端判断
export var isH5 = PLATFORM === 'h5';
export var themeMap = {
  old: 'lynkco-theme-old',
  common: 'lynkco-theme-4',
  dark: 'lynkco-theme-dark',
  light: 'lynkco-theme-light'
};
export var themeEnum = {
  old: '-1',
  dark: '0',
  light: '1'
};

// 当前主题变量--响应式
export var themeData = Vue.observable({
  // 当前主题
  currentTheme: themeMap.dark,
  // 是否旧主题
  isOldTheme: true,
  // 新版浅色主题
  isLightTheme: false,
  // 新版深色主题
  isDarkTheme: false
});
function getCurrentTheme() {
  return themeData.currentTheme;
}
function setCurrentTheme(theme) {
  themeData.currentTheme = theme;
  themeData.isOldTheme = isOldTheme();
  themeData.isLightTheme = isLightTheme();
  themeData.isDarkTheme = isDarkTheme();
}

// 是否旧主题
var isOldTheme = function isOldTheme() {
  return getCurrentTheme() === themeMap.old;
};

// 4.0深色主题
var isDarkTheme = function isDarkTheme() {
  return getCurrentTheme() === themeMap.dark;
};

// 4.0浅色主题
var isLightTheme = function isLightTheme() {
  return getCurrentTheme() === themeMap.light;
};

// 只支持存在主题模式的图片
export function getImageUrlByTheme(imageName) {
  var theme = '';
  switch (getCurrentTheme()) {
    case themeMap.light:
      theme = 'light';
    case themeMap.dark:
      theme = 'dark';
    default:
      theme = 'dark';
  }
  return getApp().globalData.imgUrl("".concat(imageName, "_").concat(theme));
}

// 设置当前主题
export var setTheme = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(theme) {
    var themeName, root, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          console.error('setTheme', theme);
          themeName = theme;
          if (themeName) {
            _context.n = 2;
            break;
          }
          _context.n = 1;
          return getAppTheme();
        case 1:
          themeName = _context.v;
        case 2:
          if (themeName === themeEnum.dark) {
            setCurrentTheme(themeMap.dark);
          } else if (themeName === themeEnum.light) {
            setCurrentTheme(themeMap.light);
          } else {
            // setCurrentTheme(themeMap.old)
            setCurrentTheme(themeMap.dark);
          }
          root = document.documentElement; // 移除所有主题类名
          root.classList.remove(themeMap.dark, themeMap.light);
          if (!isOldTheme()) {
            _context.n = 3;
            break;
          }
          return _context.a(2);
        case 3:
          root.classList.add(getCurrentTheme());
          root.classList.add(themeMap.common);
          _context.n = 5;
          break;
        case 4:
          _context.p = 4;
          _t = _context.v;
          console.error(_t);
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[0, 4]]);
  }));
  return function setTheme(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * 调用app插件
 * @param pluginName 插件名称
 * @param methodName 方法名
 * @param args 参数
 * @returns
 */
export var cordovaExec = function cordovaExec(pluginName, methodName) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  console.log('res', 222);
  return new Promise(function (resolve, reject) {
    if (typeof cordova === 'undefined') {
      reject(new Error('cordova is not defined'));
    }
    var success = function success(res) {
      try {
        console.log('res', res);
        if (typeof res === 'string') {
          resolve(JSON.parse(res));
        } else {
          resolve(res);
        }
      } catch (error) {
        console.error(error);
        resolve(res);
      }
    };
    var fail = function fail(err) {
      console.error('cordovaExec error', err);
      reject(err);
    };
    cordova.exec(success, fail, pluginName, methodName, args);
  });
};

// 是否4.0版本
export var isVersion4 = function isVersion4() {
  return checkVersion('4.0.0');
};

// 获取端上当前主题
export var getAppTheme = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var theme, res, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          theme = themeEnum.dark; // cordova环境并且大于4.0版本，获取端上主题
          console.log('isH5', cordovaExec);
          if (!true) {
            _context2.n = 4;
            break;
          }
          _context2.p = 1;
          _context2.n = 2;
          return cordovaExec('SWCThemePlugin', 'getThemeStyle');
        case 2:
          res = _context2.v;
          console.log('getThemeStyle', res);
          theme = res.data.themeStyle;
          _context2.n = 4;
          break;
        case 3:
          _context2.p = 3;
          _t2 = _context2.v;
          console.error(_t2);
        case 4:
          return _context2.a(2, theme);
      }
    }, _callee2, null, [[1, 3]]);
  }));
  return function getAppTheme() {
    return _ref2.apply(this, arguments);
  };
}();
var theme4Routes = [
// 选配页
'/pages/lynk-fullcar/configure/page-series',
// 预览配置
'/pages/lynk-fullcar/configure/page-preview',
// 确认订单
'/pages/lynk-fullcar/order/confirm/index',
// 心愿单详情
'/pages/new-vehicle/wishDetail/index',
// 配置详情
'/pages/lynk-fullcar/configDetail/index'];
// 是否双色页面
export var isTheme4Route = function isTheme4Route(path) {
  return theme4Routes.includes(path);
};

// 获取主题模式图片
export var getThemeImage = function getThemeImage(name) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'png';
  var fileName = name;
  if (themeData.isLightTheme) {
    fileName += '_light';
  } else {
    fileName += '_dark';
  }
  return require("@/assets/image-light/".concat(fileName, ".").concat(suffix));
};